<script setup>
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  startDate: {
    type: String,
    required: true,
  },
  endDate: {
    type: String,
    required: true,
  },
  courseId: {
    type: [String, Number],
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const rerunRounds = async () => {
  await store.dispatch("course/rerunRounds", {
    courseId: props.courseId,
    start_date: props.startDate,
    end_date: props.endDate,
  });
  emit("update:modelValue", false);
};

const closeModal = () => {
  emit("update:modelValue", false);
  console.log("start", props.startDate);
};
</script>

<template>
  <div v-if="modelValue">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <div class="question-mark-icon">
              <font-awesome-icon :icon="['fas', 'question']" size="3x" />
            </div>
          </div>

          <div class="modal-body d-flex flex-column align-items-center">
            <div class="row">
              <h1 class="text-center bold">Rerun Rounds</h1>
            </div>
            <div class="row">
              <h6>Re-run rounds from {{ startDate }} to {{ endDate }}</h6>
            </div>
          </div>

          <div class="modal-footer justify-content-center">
            <button type="button" class="btn btn-success" @click="rerunRounds">
              Yes, re-run!
            </button>
            <button type="button" class="btn btn-danger" @click="closeModal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";

.question-mark-icon {
  display: flex;
  justify-content: center;
  border: 3px solid #fefefe;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  size: "3x";
}

.modal-header {
  border-bottom: none !important;
}

.modal-footer {
  border-top: none !important;
}
</style>
